import "./productGalleryLightbox.css";

import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

function ProductGalleryLightbox({ brand, index = 0, open, onClose }) {
  if (!brand) {
    return null;
  }

  const slides = brand.src.map((image, slideIndex) => ({
    src: image,
    thumbnail: image,
    alt: `${brand.tagLabel || brand.name} ${slideIndex + 1}`,
    title: brand.name,
    description: `${slideIndex + 1} / ${brand.src.length}`,
  }));

  return (
    <Lightbox
      open={open}
      close={onClose}
      index={index}
      slides={slides}
      plugins={[Counter, Captions, Thumbnails, Fullscreen, Zoom]}
      counter={{ separator: " / " }}
      captions={{ descriptionTextAlign: "center", descriptionMaxLines: 1 }}
      controller={{ closeOnBackdropClick: true }}
      zoom={{ maxZoomPixelRatio: 2.5, zoomInMultiplier: 1.8 }}
      thumbnails={{
        position: "bottom",
        width: 108,
        height: 72,
        border: 0,
        borderRadius: 18,
        padding: 0,
        gap: 12,
        vignette: false,
        showToggle: false,
      }}
      className="product-gallery-lightbox"
    />
  );
}

export default ProductGalleryLightbox;
